// Look of the native-app startup takeover screen (cookie consent on first
// launch). Spread it and add the z-index (theme.zIndex.modal — above TopBar at
// 10 and the BottomNavigationBar at theme.zIndex.drawer).
export const startupScreenSx = {
  bgcolor: 'background.paper',
  bottom: 0,
  boxShadow: 3,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  left: 0,
  p: 3,
  pb: 'calc(env(safe-area-inset-bottom, 0px) + 24px)',
  position: 'fixed',
  right: 0,
  top: 0,
};
